if (!window.FoxThemeProductCardChipsInit) {
  window.FoxThemeProductCardChipsInit = true;

  function selectChip(chip) {
    const card = chip.closest('.product-card');
    if (!card) return;

    card.querySelectorAll('.product-card__chip').forEach(function (btn) {
      const isSelected = btn === chip;
      btn.classList.toggle('is-active', isSelected);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    const variantId = chip.dataset.variantId;
    const price = chip.dataset.price;
    const comparePrice = chip.dataset.comparePrice;
    const onSale = chip.dataset.onSale === 'true';
    const available = chip.dataset.available === 'true';
    const imageUrl = chip.dataset.image;
    const imageSrcset = chip.dataset.imageSrcset;

    const priceEl = card.querySelector('[data-card-price]');
    if (priceEl && price) {
      priceEl.textContent = price;
    }

    const comparePriceEl = card.querySelector('[data-card-compare-price]');
    if (comparePriceEl) {
      comparePriceEl.hidden = !onSale;
      if (onSale) {
        const strikeEl = comparePriceEl.querySelector('s');
        if (strikeEl) strikeEl.textContent = comparePrice;
      }
    }

    const imageEl = card.querySelector('.product-card__image--main img');
    if (imageEl && imageUrl) {
      imageEl.src = imageUrl;
      imageEl.srcset = imageSrcset || '';
    }

    card.querySelectorAll('[data-card-variant-input]').forEach(function (input) {
      input.value = variantId;
      input.disabled = !available;
    });

    card.querySelectorAll('[data-card-atc-button]').forEach(function (btn) {
      btn.disabled = !available;

      const textEl = btn.querySelector('[data-card-atc-text]');
      if (textEl) {
        textEl.textContent = available
          ? textEl.dataset.labelAvailable
          : textEl.dataset.labelSoldout;
      }
    });
  }

  document.addEventListener('click', function (event) {
    const chip = event.target.closest('.product-card__chip');
    if (!chip) return;
    selectChip(chip);
  });

  // Entry points that promote a specific size (e.g. the homepage "Now in 15ml!" banner)
  // link to their collection with ?default_chip_size=15, so every card on that landing
  // defaults to the matching chip instead of whichever variant is first in the list.
  const presetSize = new URLSearchParams(window.location.search).get('default_chip_size');
  if (presetSize) {
    document.querySelectorAll('.product-card__chip').forEach(function (chip) {
      if (chip.textContent.trim().toLowerCase().indexOf(presetSize.toLowerCase()) === 0) {
        selectChip(chip);
      }
    });
  }
}
